import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import config from 'utils/config';
import api from 'utils/api';
import { fetchMindsetAgent } from 'actions/userProfile/useFetchMindsetAgent';
// ID of the container where the Mindset SDK will be rendered
export var MINDSET_ID = 'mindset-container';
function renderMindsetAi(_x, _x2) {
  return _renderMindsetAi.apply(this, arguments);
}
function _renderMindsetAi() {
  _renderMindsetAi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(appUid, agentUid) {
    var _yield$api, authToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return api('get', '/api/mindset/authToken');
        case 2:
          _yield$api = _context.sent;
          authToken = _yield$api.authToken;
          // Initiate the Mindset SDK
          window.mindset.init({
            appUid: appUid,
            authToken: authToken
          });
          window.mindset.render({
            containerId: MINDSET_ID,
            component: 'agent',
            options: {
              agentUid: agentUid
            }
          });
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _renderMindsetAi.apply(this, arguments);
}
export function addMindsetAIIfRequired() {
  return _addMindsetAIIfRequired.apply(this, arguments);
}
function _addMindsetAIIfRequired() {
  _addMindsetAIIfRequired = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var render,
      appUid,
      _yield$fetchMindsetAg,
      agentUid,
      _firstScript$parentNo,
      newScript,
      firstScript,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          render = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
          appUid = config.mindsetAppUid;
          if (appUid) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return");
        case 4:
          _context2.next = 6;
          return fetchMindsetAgent();
        case 6:
          _yield$fetchMindsetAg = _context2.sent;
          agentUid = _yield$fetchMindsetAg.agentUid;
          if (agentUid) {
            _context2.next = 10;
            break;
          }
          return _context2.abrupt("return");
        case 10:
          if (document.getElementById('mindsetAIScript')) {
            _context2.next = 21;
            break;
          }
          newScript = document.createElement('script');
          newScript.type = 'text/javascript';
          newScript.async = true;
          newScript.src = "https://".concat(appUid, ".mindset.ai/mindset-sdk.js");
          newScript.id = 'mindsetAIScript';
          if (render) {
            newScript.addEventListener('load', function () {
              renderMindsetAi(appUid, agentUid);
            });
          }
          firstScript = document.getElementsByTagName('script')[0];
          (_firstScript$parentNo = firstScript.parentNode) === null || _firstScript$parentNo === void 0 ? void 0 : _firstScript$parentNo.insertBefore(newScript, firstScript);
          _context2.next = 24;
          break;
        case 21:
          if (!render) {
            _context2.next = 24;
            break;
          }
          _context2.next = 24;
          return renderMindsetAi(appUid, agentUid);
        case 24:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _addMindsetAIIfRequired.apply(this, arguments);
}